import { WithPagination } from '@bv/api/crud';

class ContactTagApi extends WithPagination<ContactTagItem> {
  public constructor(public endpoint = 'contacts/all-tags') {
    super(endpoint);
  }
}

export const contactTagApi = new ContactTagApi();
